import { useState } from 'react';

export default function VpnRequired({ onRetry }) {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    setRetrying(true);
    try {
      await onRetry();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 px-6">
      <div className="max-w-md w-full bg-white border border-border rounded-2xl p-8 text-center">
        <div className="text-5xl mb-4" aria-hidden="true">🔒</div>
        <h1 className="text-2xl font-medium text-ink mb-3">VPN required</h1>
        <p className="text-sm text-muted mb-8 leading-relaxed">
          Connect to the corporate VPN to access VF AI Launchpad. This service is
          restricted to the company network.
        </p>
        <button
          onClick={handleRetry}
          disabled={retrying}
          className="text-sm bg-ink text-white rounded-lg px-6 py-3 hover:opacity-90 disabled:opacity-50"
        >
          {retrying ? 'Checking…' : 'Retry connection'}
        </button>
      </div>
    </div>
  );
}